import { goerli, mainnet, optimism, optimismGoerli, polygon, polygonMumbai } from '@wagmi/chains'
import { ArpeggiSupportedChain } from '../../types'

const PROD_CHAIN_IDS: Record<ArpeggiSupportedChain, number> = {
  ethereum: mainnet.id,
  polygon: polygon.id,
  optimism: optimism.id
}

const DEV_CHAIN_IDS: Record<ArpeggiSupportedChain, number> = {
  ethereum: goerli.id,
  polygon: polygonMumbai.id,
  optimism: optimismGoerli.id
}

export const getChainId = (chain: ArpeggiSupportedChain): number | undefined => {
  if (!chain) return undefined

  // Support Next and server side environments
  if (process.env.NEXT_PUBLIC_ENV === 'prod' || process.env.ENV === 'prod') {
    return PROD_CHAIN_IDS[chain]
  }

  return DEV_CHAIN_IDS[chain]
}
